import { Component, OnInit, ChangeDetectionStrategy, Input, SimpleChanges, OnChanges } from '@angular/core';
import { Contract } from 'src/app/snatch/models/contract.model';
import { differenceInDays } from 'date-fns';

@Component({
  selector: 'leap-license-agreement',
  templateUrl: './license-agreement.component.html',
  styleUrls: ['./license-agreement.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LicenseAgreementComponent implements OnInit, OnChanges {

  @Input() segmentsMapper: Map<string, Contract>;
  validContract: { expiryDate: number }

  constructor() { }

  ngOnInit() { }

  ngOnChanges(changes: SimpleChanges) {
    const contracts: Contract[] = changes.segmentsMapper && Array.from(changes.segmentsMapper.currentValue.values());
    if (contracts.length) {
      const validContracts = contracts
        .filter((_: Contract) => _.status.configKey === 'contract-signed')
        .filter((_: Contract) => !_.expiryDate || differenceInDays(new Date(_.expiryDate * 1000), new Date()) > 0 )
        .sort((a, b) => b.expiryDate - a.expiryDate);

      if (validContracts.length) this.validContract = validContracts[0];
    }
  }

}
